import NewGeneralAPI from "src/api/new-interfaces/live/general";
import { WHITELISTED_BENEFICIARY_BANKS } from "src/consts/banks";
import { DORMANT_FEATURES } from "src/consts/dormant-features";

export const FETCH_BENEFICIARY_BANKS = "FETCH_BENEFICIARY_BANKS";
export const SUCCESS_FETCH_BENEFICIARY_BANKS = "SUCCESS_FETCH_BENEFICIARY_BANKS";
export const FAILED_FETCH_BENEFICIARY_BANKS = "FAILED_FETCH_BENEFICIARY_BANKS";

export const fetchBeneficiaryBanks = (getBanksEndpoint) => async (dispatch) => {
  const isFetchingBanksFromAPI = DORMANT_FEATURES.FETCH_BANKS_FROM_API;
  const getBanks = getBanksEndpoint || NewGeneralAPI.getBeneficiayBanksGroups;
  dispatch({ type: FETCH_BENEFICIARY_BANKS });

  try {
    const bankResponse = await getBanks();
    const banks = {};
    Object.keys(bankResponse).forEach((bankType) => {
      banks[bankType] = bankResponse[bankType].filter((bank) => WHITELISTED_BENEFICIARY_BANKS.includes(bank.bank_code));
    });
    dispatch({ type: SUCCESS_FETCH_BENEFICIARY_BANKS, payload: isFetchingBanksFromAPI ? bankResponse : banks });
  } catch (errors) {
    dispatch({ type: FAILED_FETCH_BENEFICIARY_BANKS, payload: errors });
  }
};
